// WebSocket 預設版號
var webSocketValueWin = '1.3.3.4';
var betaWebSocketValueWin = '1.3.3.4';
var webSocketValueMac = '1.2.3mac';
var betaWebSocketValueMac = '1.2.3mac';
// 檢查支援 OS 系統
export var checkOS = function (osName) {
    return osName === 'Windows' || osName === 'Mac';
};
// 給 OS 支援的版號
export var getCurrentVersion = function (osName) {
    if (osName === 'Windows') {
        return [webSocketValueWin, betaWebSocketValueWin];
    }
    if (osName === 'Mac') {
        return [webSocketValueMac, betaWebSocketValueMac];
    }
    return ['NVL', 'NVL'];
};
// 只有用判斷IE瀏覽器 < IE10 不能使用
export var checkBrowser = function (browserName, browserVersion) { return !(browserName === 'IE' && Number(browserVersion) < 10); };
// 檢查WebSocket版本  正式版 與 beta 都可以
export var versionOld = function (local_WebSocket_value, osName) {
    return local_WebSocket_value < getCurrentVersion(osName)[0].replace('mac', '') &&
        local_WebSocket_value < getCurrentVersion(osName)[1].replace('mac', '');
};
export var WebSocketTest = function (url, onopen, onmessage, onerror) {
    if (!('WebSocket' in window)) {
        if (process.env.REACT_APP_DEBUG_MODE === 'ON') {
            throw new Error('This browser does not support WebSockets.');
        }
    }
    var ws = new WebSocket("wss://localhost:9991/ws/" + url);
    // 成功找到元件，ws.send(JSON.stringify(params)) 發資料 會進入 onmessage
    ws.onopen = onopen(ws);
    ws.onmessage = onmessage(ws);
    // 找不到元件
    ws.onerror = onerror(ws);
};
// const params = {}
// WebSocketTest("version",
//     ws => () => {
//         ws.send(JSON.stringify(params));
//     },
//     ws => evt => {
//         var obj = JSON.parse(evt.data);
//         // postProcess(evt, obj);
//         ws.close();
//     },
//     ws => error => { console.log("Error code=" + ws.readyState + "," + error); }
// )
